import React, { useState } from 'react';
import RefereeModal from './RefereeModal';

function BetList({ bets, title, onBetResolved, emptyMessage, currentUserEmail }) {
  const [winnerEmail, setWinnerEmail] = useState('');
  const [actualResult, setActualResult] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [consultingBet, setConsultingBet] = useState(null);

  const handleResolveBet = async (bet) => {
    setError('');
    setSuccess('');

    let requestBody = {};

    if (bet.requires_response) {
      // Counter-prediction bet: use actual_result
      if (!actualResult) {
        setError('Please enter the actual result.');
        return;
      }
      requestBody = { actual_result: actualResult };
    } else {
      // Regular bet: use winner_email
      if (!winnerEmail) {
        setError('Please select a winner.');
        return;
      }
      requestBody = { winner_email: winnerEmail };
    }

    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + `/bets/${bet.id}/resolve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-Email': currentUserEmail
        },
        credentials: 'include',
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const resolvedBet = await response.json();
        setSuccess(`Pint #${bet.id} settled!`);
        onBetResolved(resolvedBet); // Callback to update parent state
        setWinnerEmail('');
        setActualResult('');
      } else {
        const errorData = await response.json();
        setError(errorData.detail || 'Failed to settle pint.');
      }
    } catch (err) {
      setError('Network error or server unavailable.');
    }
  };

  return (
    <section>
      <h2>{title}</h2>
      <div>
        {error && <p style={{ color: 'var(--color-danger)' }}>{error}</p>}
        {success && <p style={{ color: 'var(--color-irish-green-glow)' }}>{success}</p>}
        {bets.length > 0 ? (
          <ul className="BetList">
            {bets.map((bet) => (
              <li key={bet.id} className="BetList-item">
                <p style={{ marginBottom: '15px', fontSize: '16px' }}><strong>"{bet.description}"</strong></p>
                <p><strong>Who called the round:</strong> {bet.creator_name}</p>
                {bet.requires_response && bet.creator_prediction && (
                  <p><strong>Creator's Prediction:</strong> {bet.creator_prediction}</p>
                )}
                <p><strong>Who's in the round:</strong> {bet.participants_names.join(', ')}</p>
                <p><strong>Time called:</strong> {new Date(bet.created_at).toLocaleDateString()}</p>
                {bet.expires_at && <p><strong>Expires:</strong> {new Date(bet.expires_at).toLocaleDateString()}</p>}
                {bet.status === 'resolved' && (
                  <>
                    <p><strong>To the victor goes the spoils:</strong> {bet.winner_name}</p>
                    {bet.requires_response && bet.actual_result && (
                      <p><strong>Actual Result:</strong> {bet.actual_result}</p>
                    )}
                  </>
                )}

                {bet.status === 'active' && (
                  <>
                    <div className="Bet-consult-ref">
                      <button
                        className="ConsultRef-button"
                        onClick={() => setConsultingBet(bet)}
                      >
                        🔍 Consult the Ref
                      </button>
                    </div>
                    <div className="Bet-resolve-container">
                    {bet.requires_response ? (
                      // Counter-prediction bet: show actual result input
                      <div>
                        <label htmlFor={`result-${bet.id}`}>What was the actual result?</label>
                        <input
                          type="text"
                          id={`result-${bet.id}`}
                          value={actualResult}
                          onChange={(e) => setActualResult(e.target.value)}
                          placeholder="e.g., 26.8"
                        />
                        <button onClick={() => handleResolveBet(bet)}>
                          Settle Pint
                        </button>
                      </div>
                    ) : (
                      // Regular bet: show winner dropdown
                      <div>
                        <label htmlFor={`winner-${bet.id}`}>Select Winner:</label>
                        <select
                          id={`winner-${bet.id}`}
                          value={winnerEmail}
                          onChange={(e) => setWinnerEmail(e.target.value)}
                        >
                          <option value="">--Select--</option>
                          {bet.participants_emails.map((email, idx) => (
                            <option key={email} value={email}>
                              {bet.participants_names[idx] || email.split('@')[0]}
                            </option>
                          ))}
                        </select>
                        <button onClick={() => handleResolveBet(bet)}>
                          Settle Pint
                        </button>
                      </div>
                    )}
                  </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        ) : (
          <p>{emptyMessage || `No ${title.toLowerCase()} found.`}</p>
        )}
      </div>

      {consultingBet && (
        <RefereeModal
          bet={consultingBet}
          onClose={() => setConsultingBet(null)}
          currentUserEmail={currentUserEmail}
        />
      )}
    </section>
  );
}

export default BetList;
